import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class ConfigurationService {
	nameApp: string;
	lingua$: Observable<string>;
	servicePaths: Map<string, string>;
	userProfile: any;
	appPath: any;

	constructor(configurazioneModulo: any) {
		this.nameApp = configurazioneModulo.nameApp;
		this.lingua$ = configurazioneModulo.lingua$;
		this.servicePaths = configurazioneModulo.servicePaths;
		this.userProfile = configurazioneModulo.userProfile;
		this.appPath = configurazioneModulo.appPath;
	}
}